/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-03-19 00:25:20
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormLayout } from '@shopify/polaris';
import { Field } from 'redux-form';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { RenderSelect } from 'src/components/views/common/forms/render-select';
import TreeTags from 'src/components/views/filter-tree/item/option-modal/general-tab/multi-level-tag/tree-tags';
import multiLevelTagHelper from 'src/helpers/filter-tree-option/multi-level-tag-helper';
import { FILTER_OPTION_SELECT_TYPES } from 'src/constants/filter-tree';

import * as MultiLevelActions from 'actions/filter-tree/multi-level-actions';

type Props = WithI18nProps;

class MultiLevelTag extends Component<Props, State> {
  render() {
    const { tags, multiLevelTagManualValues, i18n } = this.props;

    // Remove selected tags
    const uniqueTags = multiLevelTagHelper.removeSelectedTags(tags, multiLevelTagManualValues);

    const optionSelect = FILTER_OPTION_SELECT_TYPES.map(function (type) {
      return {
        ...type,
        label: i18n.translate(type.label)
      };
    });

    return (
      <FormLayout>
        <Field
          name="multiLevelTagOptionSelect"
          component={RenderSelect}
          label={i18n.translate(
            'AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_OptionSelect_Label'
          )}
          options={optionSelect}
          tooltip={i18n.translate(
            'AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_OptionSelect_Tooltip'
          )}
        />

        <TreeTags
          tagOptions={uniqueTags}
          formValues={multiLevelTagManualValues}
          label={i18n.translate(
            'AdminHTML.FilterTree.Item.optionModal_GeneralTab_MultiLevelTag_TreeTagsLabel'
          )}
          tooltip={i18n.translate(
            'AdminHTML.FilterTree.Item.optionModal_GeneralTab_Field_OptionSelect_Tooltip'
          )}
          updateManualValues={this.updateManualValues}
        />
      </FormLayout>
    );
  }

  updateManualValues = updatedList => {
    // Dispatch action to update manual values tag
    this.props.updateManualValues(updatedList);
  };
}

const mapStateToProps = (state, props) => {
  const multiLevelTags = _.get(state.multiLevelFilterOption, 'multiLevelTags', {});

  return {
    tags: _.get(state.filterData.filterData, 'tags', []),
    multiLevelTagManualValues: _.get(multiLevelTags, 'multiLevelTagManualValues', [])
  };
};

const mapDispatchToProps = dispatch => ({
  updateManualValues: manualValues =>
    dispatch(MultiLevelActions.updateManualValuesMultiLevelTags(manualValues))
});

export default connect(mapStateToProps, mapDispatchToProps)(withI18n()(MultiLevelTag));
